import React, { useState } from "react";
import axios from "axios";
import APIConfig from "../Common/Configurations/APIConfig"; // Fixed path
import Navbar from "../Navigation/Navbar";
import Swal from "sweetalert2";
import { Lock, ShieldCheck, CheckCircle, Loader2, Eye, EyeOff } from "lucide-react";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [showPass, setShowPass] = useState({ cur: false, new: false, con: false });
  const [loading, setLoading] = useState(false);

  const userId = localStorage.getItem("userId");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      return Swal.fire("Error", "New passwords do not match!", "error");
    }

    setLoading(true);
    try {
      const response = await axios.post(
        APIConfig.APIACTIVEURL + APIConfig.CHANGE_PASSWORD,
        {
          userId: userId,
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword
        }
      );

      if (response.status === 200) {
        Swal.fire("Success", "Password updated successfully!", "success");
        setFormData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      }
    } catch (error) {
      const msg = error.response?.data?.map(e => e.description).join(", ") || "Failed to update password";
      Swal.fire("Error", msg, "error");
    }
    setLoading(false);
  };

  const styles = {
    container: { padding: "40px 60px", backgroundColor: "#f4f7fe", minHeight: "calc(100vh - 70px)", display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: "'Inter', sans-serif" },
    card: { backgroundColor: "#fff", borderRadius: "30px", padding: "40px", width: "500px", boxShadow: "0 20px 50px rgba(0,0,0,0.05)" },
    inputGroup: { marginBottom: "20px" },
    label: { display: "block", fontSize: "12px", fontWeight: "800", color: "#a3aed0", marginBottom: "8px", textTransform: 'uppercase' },
    input: { width: "100%", padding: "14px", borderRadius: "12px", border: "1.5px solid #e2e8f0", outline: "none", fontSize: "14px", boxSizing: "border-box" },
    btn: { width: "100%", backgroundColor: "#4f46e5", color: "#fff", border: "none", padding: "14px", borderRadius: "12px", fontWeight: "700", cursor: "pointer", marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }
  };

  return (
    <>
        <Navbar />
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <div style={{ background: '#eef2ff', width: '60px', height: '60px', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 15px auto' }}>
              <ShieldCheck color="#4f46e5" size={32} />
            </div>
            <h2 style={{ fontSize: '24px', fontWeight: '900', color: '#1b2559', margin: 0 }}>Update Password</h2>
            <p style={{ color: '#a3aed0', marginTop: '5px', fontSize: '14px' }}>Ensure your account stays secure.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Current Password</label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPass.cur ? "text" : "password"} 
                  required 
                  style={styles.input} 
                  value={formData.currentPassword} 
                  onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })} 
                />
                <button type="button" onClick={() => setShowPass({ ...showPass, cur: !showPass.cur })} style={{ position: 'absolute', right: '12px', top: '14px', background: 'none', border: 'none', color: '#cbd5e1', cursor: 'pointer' }}>
                  {showPass.cur ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>New Password</label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPass.new ? "text" : "password"} 
                  required 
                  style={styles.input} 
                  value={formData.newPassword} 
                  onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })} 
                />
                <button type="button" onClick={() => setShowPass({ ...showPass, new: !showPass.new })} style={{ position: 'absolute', right: '12px', top: '14px', background: 'none', border: 'none', color: '#cbd5e1', cursor: 'pointer' }}>
                  {showPass.new ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Confirm New Password</label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPass.con ? "text" : "password"} 
                  required 
                  style={styles.input} 
                  value={formData.confirmPassword} 
                  onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })} 
                />
                <button type="button" onClick={() => setShowPass({ ...showPass, con: !showPass.con })} style={{ position: 'absolute', right: '12px', top: '14px', background: 'none', border: 'none', color: '#cbd5e1', cursor: 'pointer' }}>
                  {showPass.con ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={styles.btn}>
              {loading ? <Loader2 className="animate-spin" size={20} /> : <CheckCircle size={20} />}
              {loading ? "Processing..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;